import { reportFileName } from './reportFileName';

export type ReportsTabKey = 'skus' | 'fixed-costs' | 'sales-history' | string;

/**
 * UC-121 AC-10: the variant/SKU-grain Reports tab surface's visible label
 * reads "Variants" (not "Products"). This is a UI-copy-only rename -- the
 * underlying report type value ('skus') driving data/filters/calculations
 * is unchanged (BR-INC11-8).
 *
 * Single source of truth for OrganisationReportsTab.tsx's header and
 * tab-trigger label, so tests can exercise the exact string the component
 * renders instead of a hand-copied replica.
 */
export function getReportsTabLabel(activeReportTab: ReportsTabKey): string {
  return activeReportTab === 'skus'
    ? '∑: Variants'
    : activeReportTab === 'fixed-costs'
      ? 'Fixed Costs'
      : 'Sales History';
}

/**
 * Per-item label in the completed-exports list. Same UI-copy-only rename as
 * `getReportsTabLabel`: the stored `table_name` value ('skus') is untouched.
 */
export function getReportsExportItemLabel(tableName: string | null | undefined): string {
  if (tableName === 'skus') return 'variants';
  return tableName || 'Report Export';
}

/**
 * Filename offered when downloading a completed report export (FIG-345 UC-232):
 * `YYYYMMDD_<clean merchant name>_<Report>.csv`, dated to the day the data runs
 * to. Report exports always run to the day they were created (Trailing 12
 * months to today), so the export's created_at gives that day.
 */
export function getReportsExportDownloadFilename(
  displayName: string,
  tableName: string | null | undefined,
  createdAt?: string | null,
): string {
  const created = createdAt ? new Date(createdAt) : new Date();
  return reportFileName({
    merchantName: displayName,
    reportType: tableName,
    dataDate: Number.isNaN(created.getTime()) ? new Date() : created,
  });
}
